<template>
  <div class="layout-page">
    <div class="layout-page-header">
      <CommonHeader />
    </div>
    <div class="layout-page-main">
      <div class="layout-page-aside">
        <slot name="aside" />
      </div>
      <div class="layout-page-content">
        <slot name="content" />
      </div>
    </div>
    <div class="layout-page-footer">
      <CommonFixedBanner :texts="bannerTexts" />
    </div>
  </div>
</template>

<script setup lang="ts">
import CommonHeader from '../common/CommonHeader.vue'
import CommonFixedBanner from '../common/CommonFixedBanner.vue'

const bannerTexts = [
  "Adoptons les bons réflexes pour le chauffage et la climatisation : une température de 19°C en hiver et de 24°C en été suffisent généralement pour assurer un confort satisfaisant. Réduire le chauffage et la climatisation, c’est baisser notre consommation d’électricité et nos émissions de CO₂ !",
  "Grâce à notre installation photovoltaïque, nous produisons une partie de notre électricité de manière renouvelable. Une énergie propre, locale et sans émission de CO₂ !",
  "Les toilettes du siège sont alimentées en eau de pluie dans la majorité des cas. L’eau peut paraître légèrement trouble : c’est normal et sans danger. Une démarche pertinente pour préserver nos ressources !",
  "Réduisons et trions nos déchets ! Le recyclage permet de donner en effet une seconde vie aux matériaux et de limiter significativement notre impact environnemental."
]
</script>

<style lang="scss" scoped>
.layout-page {
  width: 100vw;
  height: 100vh;
  padding: 0 2%;

  &-content {
    padding-top: var(--spacer);
    display: flex;
    gap: var(--spacer-2);
    align-items: start;
    max-height: 100%;
  }

  &-aside {
    min-height: 0;
    height: 100%;
  }
}

.layout-page-header {
  height: 15%;

  &:after {
    content: '';
    display: block;
    width: 100vw;
    height: 4px;
    background-color: var(--vc-primary);
    transform: translateY(-4px) translateX(-2%);
  }
}

.layout-page-main {
  display: grid;
  height: 80%;
  grid-template-columns: 20% 1fr;
  gap: var(--spacer);
  padding-bottom: var(--spacer);
}

.layout-page-footer {
  height: 5%;
}


.layout-page-main {
  min-height: 0;
}
</style>
